/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { RothoCalculationRequest } from '../models';
// @ts-ignore
import type { RothoCalculationResponse } from '../models';
/**
 * CalculationServiceRothoApi - axios parameter creator
 */
export const CalculationServiceRothoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate product carbon footprint for Rotho
         * @param {RothoCalculationRequest} rothoCalculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rothoCalculation: async (rothoCalculationRequest: RothoCalculationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rothoCalculationRequest' is not null or undefined
            assertParamExists('rothoCalculation', 'rothoCalculationRequest', rothoCalculationRequest)
            const localVarPath = `/calculation/v1/calculate/pcf-rotho`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rothoCalculationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServiceRothoApi - functional programming interface
 */
export const CalculationServiceRothoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServiceRothoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate product carbon footprint for Rotho
         * @param {RothoCalculationRequest} rothoCalculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rothoCalculation(rothoCalculationRequest: RothoCalculationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RothoCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rothoCalculation(rothoCalculationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceRothoApi.rothoCalculation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServiceRothoApi - factory interface
 */
export const CalculationServiceRothoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServiceRothoApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate product carbon footprint for Rotho
         * @param {CalculationServiceRothoApiRothoCalculationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rothoCalculation(requestParameters: CalculationServiceRothoApiRothoCalculationRequest, options?: RawAxiosRequestConfig): AxiosPromise<RothoCalculationResponse> {
            return localVarFp.rothoCalculation(requestParameters.rothoCalculationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for rothoCalculation operation in CalculationServiceRothoApi.
 */
export interface CalculationServiceRothoApiRothoCalculationRequest {
    readonly rothoCalculationRequest: RothoCalculationRequest
}

/**
 * CalculationServiceRothoApi - object-oriented interface
 */
export class CalculationServiceRothoApi extends BaseAPI {
    /**
     * 
     * @summary Calculate product carbon footprint for Rotho
     * @param {CalculationServiceRothoApiRothoCalculationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rothoCalculation(requestParameters: CalculationServiceRothoApiRothoCalculationRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceRothoApiFp(this.configuration).rothoCalculation(requestParameters.rothoCalculationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

